import { AxiosInstance } from "axios";
import { Usuario } from "../usuarios/usuario";

export type SignInResponse = {
    usuario: Usuario
    access_token: string
    expires_at: number
}

export type MeResponse = Usuario & {
    impersonating?: boolean
    impersonator_nome?: string
}

export class AuthService {
    constructor(private api: AxiosInstance) {
    }

    async signIn(email: string, password: string): Promise<Usuario> {
        const { data } = await this.api.post<SignInResponse>('auth/signin', {
            email,
            senha: password
        })
        return data.usuario
    }

    async impersonate(id: string): Promise<Usuario> {
        const { data } = await this.api.post<SignInResponse>(`auth/impersonate/${id}`)
        return data.usuario
    }

    async stopImpersonate(): Promise<Usuario> {
        const { data } = await this.api.post<SignInResponse>('auth/stop-impersonate')
        return data.usuario
    }

    async signOut(): Promise<void> {
        await this.api.post(`auth/signout`)
    }

    async me(): Promise<MeResponse | null> {
        try {
            const { data } = await this.api.post<MeResponse>(`auth/me`)
            return data
        } catch (error) {
            return null
        }
    }
}
